import { render } from "./Zoushi.vue?vue&type=template&id=76375d0f&scoped=true"
import script from "./Zoushi.vue?vue&type=script&lang=js"
export * from "./Zoushi.vue?vue&type=script&lang=js"

import "./Zoushi.vue?vue&type=style&index=0&id=76375d0f&scoped=true&lang=css"

import exportComponent from "/Users/windy/work/vue/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76375d0f"]])

export default __exports__